@import '^scss-config';

.colorOption {
  $size: 2.875rem;

  @include pointer-no-highlight;

  width: $size;
  height: $size;

  border: 1px solid var(--theme-color-grey-20);
  border-radius: 50%;

  transition: transform 0.2s ease-in-out, border-color 0.2s ease-in-out;
  transform: scale(0.5);

  cursor: pointer;

  &.selected {
    border: 1px solid var(--theme-color-black);

    transform: scale(1);

    .colorIcon {
      transform: scale(0.8);
    }
  }

  @include hover {
    &:not(.selected) {
      border: 1px solid var(--theme-color-grey-40);

      transform: scale(0.8);

      .colorIcon {
        transform: scale(0.8);
      }
    }
  }

  .colorIcon {
    width: 100%;
    height: 100%;

    transition: transform 0.2s ease-in-out;
  }
}
